// Meters list
export const FETCH_METERS = 'FETCH_METERS';
export const FETCH_METERS_SUCCESS = 'FETCH_METERS_SUCCESS';
export const FETCH_METERS_FAIL = 'FETCH_METERS_FAIL';

// Single meter
export const FETCH_METER = 'FETCH_METER';
export const FETCH_METER_SUCCESS = 'FETCH_METER_SUCCESS';
export const FETCH_METER_FAIL = 'FETCH_METER_FAIL';

// Create meter
export const CREATE_METER = 'CREATE_METER';
export const CREATE_METER_SUCCESS = 'CREATE_METER_SUCCESS';
export const CREATE_METER_FAIL = 'CREATE_METER_FAIL';

// Update meter
export const UPDATE_METER = 'UPDATE_METER';
export const UPDATE_METER_SUCCESS = 'UPDATE_METER_SUCCESS';
export const UPDATE_METER_FAIL = 'UPDATE_METER_FAIL';

// Delete meter
export const DELETE_METER = 'DELETE_METER';
export const DELETE_METER_SUCCESS = 'DELETE_METER_SUCCESS';
export const DELETE_METER_FAIL = 'DELETE_METER_FAIL';

// Meters by asset
export const FETCH_METERS_BY_ASSET = 'FETCH_METERS_BY_ASSET';
export const FETCH_METERS_BY_ASSET_SUCCESS = 'FETCH_METERS_BY_ASSET_SUCCESS';
export const FETCH_METERS_BY_ASSET_FAIL = 'FETCH_METERS_BY_ASSET_FAIL';

// Meter readings
export const FETCH_METER_READINGS = 'FETCH_METER_READINGS';
export const FETCH_METER_READINGS_SUCCESS = 'FETCH_METER_READINGS_SUCCESS';
export const FETCH_METER_READINGS_FAIL = 'FETCH_METER_READINGS_FAIL';

// Create reading
export const CREATE_METER_READING = 'CREATE_METER_READING';
export const CREATE_METER_READING_SUCCESS = 'CREATE_METER_READING_SUCCESS';
export const CREATE_METER_READING_FAIL = 'CREATE_METER_READING_FAIL';

// Readings by work order
export const FETCH_READINGS_BY_WORK_ORDER = 'FETCH_READINGS_BY_WORK_ORDER';
export const FETCH_READINGS_BY_WORK_ORDER_SUCCESS = 'FETCH_READINGS_BY_WORK_ORDER_SUCCESS';
export const FETCH_READINGS_BY_WORK_ORDER_FAIL = 'FETCH_READINGS_BY_WORK_ORDER_FAIL';

// Clear messages
export const CLEAR_METER_MESSAGES = 'CLEAR_METER_MESSAGES';
